import "/__w/1/s/BotFramework-WebChat/packages/component/src/Attachment/Text/private/ActivityCopyButton.module_built.css";
const classes = {"activity-copy-button__copied-text":"w4rKArW_activity-copy-button__copied-text","activity-copy-button__copy-announcement":"w4rKArW_activity-copy-button__copy-announcement","activity-copy-button":"w4rKArW_activity-copy-button","activity-button__icon":"w4rKArW_activity-button__icon","activity-button__text":"w4rKArW_activity-button__text","activity-copy-button--copied":"w4rKArW_activity-copy-button--copied"}
export default classes

const _activity_copy_button__copied_text0 = classes["activity-copy-button__copied-text"]
export { _activity_copy_button__copied_text0 as "activity-copy-button__copied-text" }

const _activity_copy_button__copy_announcement0 = classes["activity-copy-button__copy-announcement"]
export { _activity_copy_button__copy_announcement0 as "activity-copy-button__copy-announcement" }

const _activity_copy_button0 = classes["activity-copy-button"]
export { _activity_copy_button0 as "activity-copy-button" }

const _activity_button__icon0 = classes["activity-button__icon"]
export { _activity_button__icon0 as "activity-button__icon" }

const _activity_button__text0 = classes["activity-button__text"]
export { _activity_button__text0 as "activity-button__text" }

const _activity_copy_button__copied0 = classes["activity-copy-button--copied"]
export { _activity_copy_button__copied0 as "activity-copy-button--copied" }
